import axios from '../helper/axios';
import { apiUrl, apiUrl2 } from '../config/config';

export async function activateWallet(postData) {
  try {
    let res = await axios.Post({
      url: `${apiUrl}/rpc/wallet/activate/validation`,
      data: postData,
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return { error: e };
    }
  }
}
export async function getWallet({ walletId }) {
  try {
    let res = await axios.Get({
      url: `${apiUrl}/BTC/${walletId}/balance`,
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return { error: e };
    }
  }
}
export async function postCashback(postData) {
  try {
    let res = await axios.Post({
      url: `${apiUrl}/cashback/initiate`,
      data: postData,
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return { error: e };
    }
  }
}
export async function getTrxHistory(postData) {
  try {
    let res = await axios.PostWithoutAuth({
      url: `${apiUrl}/wallet/history`,
      data: postData,
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return { error: e };
    }
  }
}
export async function getWalletStatSummary(params) {
  try {
    let res = await axios.Get({
      url: `${apiUrl2}/graph/stats`,
      params: params,
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return { error: e };
    }
  }
}
export async function getWalletGraphSummary(params) {
  try {
    let res = await axios.Get({
      url: `${apiUrl2}/graph/historical`,
      params: params,
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return { error: e };
    }
  }
}
